Iodine.addRule('minDigits', (value, param) => value.length >= param);
Iodine.addRule('maxDigits', (value, param) => value.length <= param);

Iodine.setErrorMessage('required', `The [FIELD] field is required.`);
Iodine.setErrorMessage( 'minLength', `The [FIELD] must not be less than [PARAM] characters.`);
Iodine.setErrorMessage('maxLength', `The [FIELD] must not be greater than [PARAM] characters.`);
Iodine.setErrorMessage( 'minDigits', `The [FIELD] must not be less than [PARAM] digits.`);
Iodine.setErrorMessage('maxDigits', `The [FIELD] must not be greater than [PARAM] digits.`);

// return {
//     after: `The date must be after: '[PARAM]'`,
//     afterOrEqual: `The date must be after or equal to: '[PARAM]'`,
//     array: `[FIELD] must be an array`,
//     before: `The date must be before: '[PARAM]'`,
//     beforeOrEqual: `The date must be before or equal to: '[PARAM]'`,
//     boolean: `[FIELD] must be true or false`,
//     date: `[FIELD] must be a date`,
//     different: `[FIELD] must be different to '[PARAM]'`,
//     endingWith: `[FIELD] must end with '[PARAM]'`,
//     email: `[FIELD] must be a valid email address`,
//     falsy: `[FIELD] must be a falsy value (false, 'false', 0 or '0')`,
//     in: `[FIELD] must be one of the following options: [PARAM]`,
//     integer: `[FIELD] must be an integer`,
//     json: `[FIELD] must be a parsable JSON object string`,
//     maximum: `[FIELD] must not be greater than '[PARAM]' in size or character length`,
//     minimum: `[FIELD] must not be less than '[PARAM]' in size or character length`,
//     max: `[FIELD] must be less than or equal to [PARAM]`,
//     min: `[FIELD] must be greater than or equal to [PARAM]`,
//     maxLength: `[FIELD] must not be greater than '[PARAM]' in character length`,
//     minLength: `[FIELD] must not be less than '[PARAM]' character length`,
//     notIn: `[FIELD] must not be one of the following options: [PARAM]`,
//     numeric: `[FIELD] must be numeric`,
//     optional: `[FIELD] is optional`,
//     regexMatch: `[FIELD] must satisify the regular expression: [PARAM]`,
//     required: `[FIELD] must be present`,
//     same: `[FIELD] must be '[PARAM]'`,
//     startingWith: `[FIELD] must start with '[PARAM]'`,
//     string: `[FIELD] must be a string`,
//     truthy: `[FIELD] must be a truthy value (true, 'true', 1 or '1')`,
//     url: `[FIELD] must be a valid url`,
//     uuid: `[FIELD] must be a valid UUID`,
// };

